(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-map-with-content-root]';
  var loadPromise = null;
  var loadKey = null;

  var STYLE_PRESETS = {
    default: null,
    silver: [
      { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
      { featureType: 'landscape', stylers: [{ color: '#f5f5f5' }] },
      { featureType: 'water', stylers: [{ color: '#c9c9c9' }] },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#d6d6d6' }]
      }
    ],
    dark: [
      { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#17263c' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#38414e' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#212a37' }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }]
      }
    ],
    retro: [
      { elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#c9b8a2' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#f5f1e6' }]
      }
    ],
    minimal: [
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'transit',
        stylers: [{ visibility: 'off' }]
      }
    ]
  };

  function loadMapsScript(apiKey) {
    if (window.google && window.google.maps) {
      return Promise.resolve();
    }
    if (loadPromise && loadKey === apiKey) {
      return loadPromise;
    }
    if (loadPromise && loadKey !== apiKey) {
      return loadPromise;
    }
    loadKey = apiKey;
    loadPromise = new Promise(function (resolve, reject) {
      var cbName = 'mapWithContentCb_' + Math.random().toString(36).slice(2);
      window[cbName] = function () {
        delete window[cbName];
        resolve();
      };
      var s = document.createElement('script');
      s.async = true;
      s.defer = true;
      s.onerror = function () {
        delete window[cbName];
        loadPromise = null;
        loadKey = null;
        reject(new Error('Google Maps failed to load'));
      };
      s.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(apiKey) +
        '&callback=' +
        cbName;
      document.head.appendChild(s);
    });
    return loadPromise;
  }

  function parseCustomStyles(el) {
    var script = el.querySelector('script.map-with-content__styles-json');
    if (!script) {
      return null;
    }
    var raw = script.textContent;
    if (!raw || !String.prototype.trim.call(raw)) {
      return null;
    }
    try {
      var parsed = JSON.parse(String.prototype.trim.call(raw));
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function buildMapOptions(el, center, zoom) {
    var mode = el.getAttribute('data-map-mode') || 'theme_styles';
    var opts = {
      center: center,
      zoom: isNaN(zoom) ? 15 : zoom,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true
    };

    if (mode === 'vector_map') {
      var mapId = el.getAttribute('data-map-id');
      if (mapId) {
        opts.mapId = mapId;
      }
      return opts;
    }

    var custom = parseCustomStyles(el);
    if (custom && custom.length) {
      opts.styles = custom;
      return opts;
    }

    var presetKey = el.getAttribute('data-style-preset') || 'default';
    var preset = STYLE_PRESETS[presetKey];
    if (preset && preset.length) {
      opts.styles = preset;
    }
    return opts;
  }

  function initMapRoot(el) {
    if (el.getAttribute('data-map-initialized') === 'true') {
      return;
    }
    var apiKey = el.getAttribute('data-api-key');
    var lat = parseFloat(el.getAttribute('data-lat'));
    var lng = parseFloat(el.getAttribute('data-lng'));
    var zoom = parseInt(el.getAttribute('data-zoom') || '15', 10);
    var markerTitle = el.getAttribute('data-marker-title') || '';
    var markerUrlAttr = el.getAttribute('data-marker-url');
    var markerUrl =
      markerUrlAttr && String.prototype.trim.call(markerUrlAttr)
        ? String.prototype.trim.call(markerUrlAttr)
        : '';
    var mode = el.getAttribute('data-map-mode') || 'theme_styles';
    var canvas = el.querySelector('.map-with-content__map-canvas');
    if (!canvas || !apiKey || isNaN(lat) || isNaN(lng)) {
      return;
    }
    if (mode === 'vector_map' && !el.getAttribute('data-map-id')) {
      return;
    }

    el.setAttribute('data-map-initialized', 'true');

    loadMapsScript(apiKey)
      .then(function () {
        var center = { lat: lat, lng: lng };
        var mapOptions = buildMapOptions(el, center, zoom);
        var map = new google.maps.Map(canvas, mapOptions);
        var markerOpts = {
          position: center,
          map: map,
          title: markerTitle
        };
        if (markerUrl) {
          markerOpts.cursor = 'pointer';
        }
        var marker = new google.maps.Marker(markerOpts);
        if (markerUrl) {
          marker.addListener('click', function () {
            window.open(markerUrl, '_blank', 'noopener,noreferrer');
          });
        }
      })
      .catch(function () {
        el.removeAttribute('data-map-initialized');
      });
  }

  var observer =
    typeof IntersectionObserver !== 'undefined'
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                initMapRoot(entry.target);
              }
            });
          },
          { rootMargin: '120px', threshold: 0.01 }
        )
      : null;

  function observeOrInit(el) {
    if (observer) {
      observer.observe(el);
    } else {
      initMapRoot(el);
    }
  }

  function scan(root) {
    var scope = root && root.querySelector ? root : document;
    var nodes = scope.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      observeOrInit(nodes[i]);
    }
  }

  function initListeners() {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector(ROOT_SELECTOR)) {
        scan(e.target);
      }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelectorAll) {
        return;
      }
      var nodes = e.target.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].removeAttribute('data-map-initialized');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      document.removeEventListener('DOMContentLoaded', onReady);
      initListeners();
      scan(document);
    });
  } else {
    initListeners();
    scan(document);
  }
})();
